import {
  IconBrandAndroid,
  IconBrandApple,
  IconBrandChrome,
  IconBrandFirefox,
  IconBrandOpera,
  IconBrandSafari,
  IconBrandUbuntu,
  IconBrandWindows,
  IconDeviceDesktop,
  IconDeviceMobile,
  IconDeviceTablet,
} from '@tabler/icons-react';

const tagIcons = {
  browser: {
    Firefox: { icon: IconBrandFirefox, tooltip: 'Firefox' },
    Chrome: { icon: IconBrandChrome, tooltip: 'Chrome' },
    Safari: { icon: IconBrandSafari, tooltip: 'Safari' },
    Opera: { icon: IconBrandOpera, tooltip: 'Opera' },
  },
  type: [
    { key: 'Mobile', icon: IconDeviceMobile, tooltip: 'Mobile' },
    { key: 'Tablet', icon: IconDeviceTablet, tooltip: 'Tablet' },
    { key: 'Desktop', icon: IconDeviceDesktop, tooltip: 'Desktop' },
  ],
  platform: {
    Linux: { icon: IconBrandUbuntu, tooltip: 'Linux' },
    'Microsoft Windows': { icon: IconBrandWindows, tooltip: 'Windows' },
    Mac: { icon: IconBrandApple, tooltip: 'Mac' },
    'Apple Mac': { icon: IconBrandApple, tooltip: 'Mac' },
    Android: { icon: IconBrandAndroid, tooltip: 'Android' },
    iPhone: { icon: IconBrandApple, tooltip: 'iPhone' },
  },
};

export default tagIcons;
